import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = {
  getConfig: async () => (await axios.get(`${API}/config`)).data,
  createSession: async (payload) => (await axios.post(`${API}/sessions`, payload)).data,
  getSession: async (id) => (await axios.get(`${API}/sessions/${id}`)).data,
  saveAnswers: async (id, answers) => (await axios.put(`${API}/sessions/${id}/answers`, { answers })).data,
  getRecommendations: async (id) => (await axios.get(`${API}/sessions/${id}/recommendations`)).data,
  submitClaim: async (id, payload) => (await axios.put(`${API}/sessions/${id}/claim`, payload)).data,
  adminLogin: async (pin) => (await axios.post(`${API}/admin/login`, { pin })).data,
  getCms: async (pin) => (await axios.get(`${API}/admin/cms`, { headers: { "X-Admin-Pin": pin } })).data,
  saveCmsItem: async (pin, type, id, payload) =>
    (await axios.put(`${API}/admin/${type}/${id}`, payload, { headers: { "X-Admin-Pin": pin } })).data,
  saveFormConfig: async (pin, payload) =>
    (await axios.put(`${API}/admin/form-config`, payload, { headers: { "X-Admin-Pin": pin } })).data,
  saveAdvisorContent: async (pin, content) =>
    (await axios.put(`${API}/admin/advisor-content`, { content }, { headers: { "X-Admin-Pin": pin } })).data,
  uploadMedia: async (pin, file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/admin/media`, fd, { headers: { "X-Admin-Pin": pin } })).data; },
  getAnalyticsSummary: async (pin, days = 30) => (await axios.get(`${API}/admin/analytics-summary`, { params: { days }, headers: { "X-Admin-Pin": pin } })).data,
  regenerateAdvisorWordpress: async (pin) =>
    (await axios.post(`${API}/admin/advisor-wordpress-export`, {}, { headers: { "X-Admin-Pin": pin } })).data,
  getAdvisorConfig: async () => (await axios.get(`${API}/advisor/config`)).data,
  routeAdvisor: async (questionId, optionId) => (await axios.post(`${API}/advisor/route`, { question_id: questionId, option_id: optionId })).data,
  submitAdvisorContact: async (payload) => (await axios.post(`${API}/advisor/contacts`, payload)).data,
  submitAdvisorDemoOffer: async (payload) => (await axios.post(`${API}/advisor/demo-offer`, payload)).data,
  submitAdvisorLead: async (payload) => (await axios.post(`${API}/advisor/leads`, payload)).data,
  captureAdvisorAnalytics: async (eventName, payload) => (await axios.post(`${API}/advisor/analytics`, { event_name: eventName, payload, session_id: payload?.sessionId || null })).data,
};

export const youtubeEmbed = (url) => {
  if (!url) return "";
  if (url.includes("/embed/")) return url;
  const id = url.includes("v=") ? url.split("v=")[1].split("&")[0] : url.split("/").pop();
  return `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`;
};